import { createRoute, useSearch } from "@tanstack/solid-router";
import { useNavigate } from "@/lib/u-router";
import { adminRoute } from "./admin";
import { EmailTemplateManager } from "@/features/admin/components/email-template-manager";
import { PageContainer } from "@/components/ui/page-container";

interface AdminEmailSearch {
  /** Abre el editor en modo creación (`?new=1`). */
  new?: boolean;
  /** Abre el editor para una plantilla existente (`?edit=<id>`). */
  edit?: string;
}

function AdminEmailPage() {
  const search = useSearch({ from: "/u/$u/admin/email" });
  const navigate = useNavigate();

  // El editor de plantillas es deep-linkable (`?new=1` / `?edit=<id>`): la URL
  // es la fuente de verdad, así un admin puede compartir "edita esta plantilla".
  const openNew = (): void => {
    void navigate({ to: "/admin/email", search: { new: true }, replace: true });
  };
  const openEdit = (id: string): void => {
    void navigate({ to: "/admin/email", search: { edit: id }, replace: true });
  };
  const closeEditor = (): void => {
    void navigate({ to: "/admin/email", search: {}, replace: true });
  };

  return (
    <PageContainer maxWidth="6xl">
      <EmailTemplateManager
        creating={Boolean(search().new)}
        editingId={search().edit}
        onNew={openNew}
        onEdit={openEdit}
        onClose={closeEditor}
      />
    </PageContainer>
  );
}

export const adminEmailRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/email",
  validateSearch: (search: Record<string, unknown>): AdminEmailSearch => ({
    // Incluye el NÚMERO 1: TanStack auto-parsea `?new=1` a number 1 (no string);
    // sin este caso el param se descartaba en el boot y el diálogo no abría por
    // deep-link (CC-18).
    new:
      search.new === true || search.new === 1 || search.new === "1" || search.new === "true"
        ? true
        : undefined,
    edit: typeof search.edit === "string" && search.edit.trim() !== "" ? search.edit : undefined,
  }),
  component: AdminEmailPage,
});
